export function HomePage(): React.JSX.Element {
  return (
    <section className="card" data-testid="home-page">
      <h2>Inventory starts here</h2>
      <p>
        This is the InventoHub shell. Catalog, events, loadouts, and inventory sessions arrive in
        later features.
      </p>
      <p className="meta">Times shown in America/Chicago.</p>
    </section>
  );
}
